import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, ViewEncapsulation } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { RequestService } from 'src/app/Services/request/request.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-agency-home',
  templateUrl: './agency-home.component.html',
  styleUrls: ['./agency-home.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AgencyHomeComponent {
  public isMobile: boolean = false;
  existeRadicado: boolean = true;

  codigo = new FormControl('', [Validators.required]);

  constructor(
    breakpointObserver: BreakpointObserver,
    public dialog: MatDialog,
    private readonly router: Router,
    private readonly requestService: RequestService,
    private readonly spinner: NgxSpinnerService,
    private readonly lsService : SessionStorageService
  ) {
    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      this.isMobile = result.matches;
    });
  }

  ngAfterViewInit() {
    if (this.existeRadicado) {
      this.codigo.enable();
    }
    else {
      this.codigo.disable();
    }

  }
  radioChange(event: MatRadioChange) {
    if (event.value) {
      this.codigo.enable();
    }
    else {
      this.codigo.setValue(null);
      this.codigo.disable();
    }
  }
  openDialog() {
    const dialogRef = this.dialog.open(AgencyHomeDialogComponent, { width: '600px' });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
  async redirect() {

    if (this.codigo.enabled && this.codigo.valid) {
     await this.spinner.show();

      let rq = await this.requestService.getRequestByCode(this.codigo.value);
      await this.spinner.hide();
      if (rq != null) {

        this.lsService.setLSItem("IdRequest", rq.Id.toString())
        this.lsService.setLSItem("RequestCode", rq.RequestCode)
        await this.router.navigate(['Register/Main/Request']);
      } else {
        await Swal.fire({
          title: 'Error!',
          text: "Solicitud No existe",
          icon: 'error'
        }
        )

      }
    }
    else if (this.codigo.disabled) {
      this.lsService.removeLSItem("IdRequest")
      this.lsService.removeLSItem("RequestCode")
      this.router.navigate(['Register/Main/Request']);
    }

  }
}
@Component({
  selector: 'agency-home-dialog',
  templateUrl: './agency-home-dialog.component.html',
  styleUrls: ['./agency-home.component.css']
})
export class AgencyHomeDialogComponent {
  public isMobile: boolean = false;
  public Home: any;
  nombre = new FormControl('', [Validators.required]);
  codigo = new FormControl('', [Validators.required]);
  placa = new FormControl('', [Validators.required]);
  monedaVenta = new FormControl('', [Validators.required]);
  monedaLocal = new FormControl('', [Validators.required]);
  constructor(breakpointObserver: BreakpointObserver) {
    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      this.isMobile = result.matches;
    });
  }

}